import type { TimeOptions } from '.';
import { Time } from './Time';

export interface SmoothTimeOptions extends TimeOptions {
  smooth?: number;
}

/**
 * Acts exactly like the regular Time function, but with an extra option for smoothing
 * delta time, artificially trying to make variation more stable, which might help against
 * some small hiccups caused by frame rate oscilation.
 */
export class SmoothTime extends Time {
  /** Linear interpolation value for smoothing the delta time. */
  public smooth: number;

  constructor(options: SmoothTimeOptions = {}) {
    super(options);
    this.smooth = options.smooth ?? 0.2;
  }

  public nextUpdate(): void {
    const now = performance.now();
    const deltaTime = Math.min(now - this._lastTime, this.maxDeltaTime);

    if (this.smooth > 0 && this.smooth < 1) {
      this._deltaTime -= (this._deltaTime - deltaTime) * this.smooth;
    } else {
      this._deltaTime = deltaTime;
    }

    this._frameTime = this._deltaTime / this._frameDuration;
    this._lastTime = now;
  }
}
